import PayrollSettingsSidebar from 'components/Global/payrollSettingSidebar';
import { FC } from 'react';
import styles from './index.module.scss';
import { SettingsLayoutProps } from './types';

// Settings page layout
const PayrollSettingsLayout: FC<SettingsLayoutProps> = (props) => {
	const { children, onSideBarChange, selectedSidebar } = props;

	return (
		<div className={styles['payrollSettings-layout']}>
			<div className={styles['payrollSettings-layout__wrapper']}>
				<PayrollSettingsSidebar
					items={[]}
					handleSidebar={onSideBarChange}
					selectedSidebar={selectedSidebar as string}
				/>
				<div className={styles['payrollSettings-layout__body']}>
					{children}
				</div>
			</div>
		</div>
	);
};

export default PayrollSettingsLayout;
